import { EVENT_SUBMIT, EVENT_FOCUS_OUT } from '../../settings';
import { ContactDetails } from '../../types';

class ContactSenser {
  static EVENTS = [EVENT_SUBMIT, EVENT_FOCUS_OUT];

  static lookForContactDetails(event: Event) {
    if (event.type === EVENT_SUBMIT) {
      return this.lookForContactDetailsFromForm(event.target as HTMLFormElement);
    }
    if (event.type === EVENT_FOCUS_OUT) {
      return this.lookForContactDetailsFromInput(event.target as HTMLInputElement);
    }
    return null;
  }

  static lookForContactDetailsFromInput(input: HTMLInputElement): ContactDetails[] | null {
    const { value } = input;
    if (value?.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)) {
      return [{ type: 'email', value }];
    }
    if (value?.match(/^[0-9]{10}$/)) {
      return [{ type: 'phone', value }];
    }
    return null;
  }

  static lookForContactDetailsFromForm(form: HTMLFormElement): ContactDetails[] {
    let listOfContactDetails: ContactDetails[] = [];
    const inputs = form.querySelectorAll('input');
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < inputs.length; i++) {
      const input = inputs[i] as HTMLInputElement;
      const contactDetails = this.lookForContactDetailsFromInput(input);
      if (contactDetails) {
        listOfContactDetails = [...listOfContactDetails, ...contactDetails];
      }
    }
    return listOfContactDetails;
  }
}

export default ContactSenser;
